import { useAppPersistenceModerationStore } from '@ninjacart/nc-nk-moderation';
import {
  KissanEventType,
  UserProps,
  useAppPersistenceStore,
  useEventZStore,
  useGlobalReportContext,
  useProfileStore,
} from '@ninjacart/nc-nk-store';
import {
  ChangeLanguageBottomSheet,
  Text,
  UIBottomSheet,
  View,
  createMaterialTopTabNavigator,
  useTheme,
  ScrollView
} from '@ninjacart/nc-nk-ui';
// import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';
// import type { PathConfigMap } from '@react-navigation/native';
import {
  INinjaEvent,
  addEventParam,
  useQueuedEventStore,
} from '@ninjacart/nc-events-sdk-v2';
import {  Footer, useFocusEffect, useRouter } from '@ninjacart/nc-nk-web-deps';
import type { PathConfigMap } from '@react-navigation/native';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dimensions, Platform, Pressable, useWindowDimensions } from 'react-native';
import { useParams, useSearchParams, useUpdateSearchParams } from 'solito/navigation';
import { getProfileUser } from '../api/kisan/getProfileUser';
import useUserEngagementStore from '../store/useUserEngagementStore';
import MyProfileTab from './myProfileTab';
import ProfileAllActivityComments from './profileAllActivityComments';
import AllQnaList from './profileAllQnaList';
import ProfileAllTab from './profileAllTab';
import AllVideos from './profileAllVideos';
import ProfileHeader from './profileHeader';

// import { Albums } from '../Shared/Albums';
// import { Chat } from '../Shared/Chat';
// import { Contacts } from '../Shared/Contacts';
const useParam = useParams<{ id: string; name: string }>;

// type Params = { id: string; name: string };

type MaterialTopTabParams = {
  All: {
    id?: string;
    userProfile: UserProps;
  };
  Profile: {
    userProfile: UserProps;
    languageChange: () => void;
    refCode: string;
    setProfileData: React.Dispatch<any>;
  };
  Video: {
    userProfile: UserProps;
    id?: string;
    hasUserLoggedIn: boolean | null;
  };
  Qna: {
    id?: string;
    userProfile: UserProps;
    hasUserLoggedIn: boolean | null;
  };
  Activity: {
    profileData: UserProps;
    id?: string;
    hasUserLoggedIn: boolean | null;
  };
};

const linking: PathConfigMap<MaterialTopTabParams> = {
  All: 'all',
  Profile: 'profile',
  Video: 'videos',
  Qna: 'qna',
  Activity: 'activity',
};

type Params = {
  tab?: string;
};

const MaterialTopTabs = createMaterialTopTabNavigator();

export const ProfileDetailScreen  = ({
  profileId,
}: {
  setEdTechAppLanguage?: any;
  profileId?: string;
}) => {
  const Tab = createMaterialTopTabNavigator();
  const { push } = useRouter();
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const [profileData, setProfileData] = useState<any>({});
  const userProfile = useProfileStore((state) => state.userProfile);
  const setUserProfile = useProfileStore((state) => state.setUserProfile);
  const feedConfig = useProfileStore((state) => state.feedConfig);
  const setOnLoginRedirect = useAppPersistenceStore((state) => state.setOnLoginRedirect);
  const hasUserLoggedIn = useProfileStore((state) => state.hasUserLoggedIn);
  const setAppLanguage = useAppPersistenceStore((state) => state.setAppLanguage);
  const setModerationAppLanguage = useAppPersistenceModerationStore(
    (state) => state.setModerationAppLanguage
  );

  const [languageChangeBottomSheet, setLanguageChangeBottomSheet] = useState(false);
  const [refCode, setRefCode] = useState('');
  const updateParams = useUpdateSearchParams<Params>();
  const searchParams = useSearchParams<Params>();
  const tab = searchParams?.get('tab');
  // const searchParams = useSearchParams<Params>()
  // const id = searchParams?.get('id');
  // const { id: id, name: name } = useParam();
  // console.log('ProfileDetailScreen id', id);
  // const name = searchParams?.get('name');
  const resetProfileActivity = useUserEngagementStore((state) => state.resetProfileActivity);
  const resetQnaFeed = useUserEngagementStore((state) => state.resetQnaFeed);
  const resetHomeFeedsCard = useUserEngagementStore((state) => state.resetHomeFeedsCard);
  const theme = useTheme();
  const { width } = useWindowDimensions();
  const isMobile = width < 768;
  const HEADER_HEIGHT = !hasUserLoggedIn() ? 170 : Platform.OS === 'web' && !isMobile ? 380 : 310;
  const setContactIndex = useEventZStore((state) => state.setContactIndex);
  const contactIndex = useEventZStore((state) => state.contactIndex);
  const enqueue = useRef(useQueuedEventStore((state) => state.enqueue)).current;
  const screenHeight = Dimensions.get('window').height;
  const tabHeight = 48 * 2;
  const [selectedIndex, setSelectedIndex] = useState(0);
  const reportfields = useGlobalReportContext(['reportIndex', 'openReportSheet']);
  const setCurrentIndex = reportfields['reportIndex'].set;
  let id: string | undefined;
  let name: string | undefined;
  const params = useParam?.();
  if (params?.id) {
    id = params.id;
    name = params.name;
  }

  id = id?.split('-').pop();

  if (profileId) {
    id = profileId.includes('-') ? profileId?.split('-').pop() : profileId;
  }

  if (userProfile?.user?.id && userProfile?.user?.id === id) {
    id = undefined;
  }

  useEffect(() => {
    let index = 0;
    switch (tab) {
      case 'profile':
        if (userProfile?.user?.id && userProfile?.user?.id === id) {
          index = 0;
        }
        break;
      case 'all':
        if (userProfile?.user?.id && userProfile?.user?.id !== id) {
          index = 0;
        }
        break;
      case 'activity':
        index = 1;
        break;
      case 'qna':
        index = 2;
        break;
      case 'video':
        index = 3;
        break;

      default:
        index = 0;
        break;
    }

    setSelectedIndex(index);
  }, [tab, userProfile, id]);

  const navigateToLogin = () => {
    setOnLoginRedirect(undefined);
    push('/login');
  };
  const fetchProfileData = async () => {
    if (!(hasUserLoggedIn() || id)) return;
    try {
      setIsLoading(true);
      if (!userProfile?.user?.id || !userProfile?.realm?.id) {
        setIsLoading(false);
        return;
      }
      const config: any = {
        userId: id ?? userProfile?.user?.id,
        realmId: id ? '1' : userProfile?.realm?.id,
        headers: feedConfig,
      };
      const response: any = await getProfileUser(config);

      setProfileData(response?.data);
      if (!id) {
        const userProfileUpdate = userProfile;
        userProfileUpdate.user = response?.data?.user;
        userProfileUpdate.realm = response?.data?.realm;
        setUserProfile(userProfileUpdate);
      }
      setRefCode(response?.data?.user?.referralCode);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      throw new Error('Error fetching data:', error);
    }
  };

  useFocusEffect(
    useCallback(() => {
      resetProfileActivity();
      resetQnaFeed();
      resetHomeFeedsCard();
      fetchProfileData();
      return () => {
        setProfileData(undefined);
      };
    }, [])
  );

  const onLanguageChange = (changedLang: string) => {
    if (changedLang) {
      setAppLanguage(changedLang);
      setModerationAppLanguage(changedLang);
    }
  };

  const languageChange = () => {
    setLanguageChangeBottomSheet(true);
    const languageChangeEvent: INinjaEvent = {
      name: KissanEventType.LANGUAGE_CHANGE_CLICK,
      screenDetails: { screen: 'profile detail page' },
    };
    enqueue(languageChangeEvent);
  };

  const handleEventOnSelf = (event) => {
    const onSelfEvent: INinjaEvent = {
      name: event,
      screenDetails: { screen: 'profile detail page' },
    };
    enqueue(onSelfEvent);
  };

  const handleEventOnTabPress = (event) => {
    const onTabPressEvent: INinjaEvent = {
      name: event,
      screenDetails: { screen: 'profile detail page' },
      eventParams: [addEventParam('otherUserId', profileData?.user?.id)],
    };
    enqueue(onTabPressEvent);
  };

  const onReportBottomSheetOpen = (item, index) => {
    setCurrentIndex(index);
    reportfields['openReportSheet'].set(true);
    const itemReportEvent: INinjaEvent = {
      name: KissanEventType.ITEM_REPORTED,
      screenDetails: { screen: 'profile detail page' },
      eventParams: [
        addEventParam('itemIndex', index),
        addEventParam('recommendationId', item?.recommendationId),
      ],
    };
    enqueue(itemReportEvent);
  };

  const tabs = [
    {
      label: id ? t('page.all') : t('page.profile'),
      component: id ? (
        <ProfileAllTab
          id={id?.toString() ?? ''}
          userProfile={userProfile}
          onReportBottomSheetOpen={onReportBottomSheetOpen}
        />
      ) : (
        <MyProfileTab
          userProfile={userProfile!}
          languageChange={languageChange}
          refCode={refCode}
          setProfileData={setProfileData}
        />
      ),
      tabPress: () => {
        updateParams({ tab: id ? 'all' : 'profile' });
        id
          ? handleEventOnTabPress(KissanEventType?.PROFILE_OTHERS_ALL)
          : handleEventOnSelf(KissanEventType?.PROFILE_SELF_MYPROFILE);
      },
    },
    hasUserLoggedIn() && {
      label: t('page.activity'),
      component: (
        <ProfileAllActivityComments
          profileData={id ? profileData : userProfile}
          id={id || undefined}
          hasUserLoggedIn={hasUserLoggedIn()}
          onReportBottomSheetOpen={onReportBottomSheetOpen}
        />
      ),
      tabPress: () => {
        updateParams({ tab: 'activity' });
        id
          ? handleEventOnTabPress(KissanEventType?.PROFILE_OTHERS_ACTIVITY)
          : handleEventOnSelf(KissanEventType?.PROFILE_SELF_ACTIVITY);
      },
    },
    hasUserLoggedIn() && {
      label: t('page.qna'),
      component: (
        <AllQnaList
          userProfile={userProfile!}
          id={id || undefined}
          hasUserLoggedIn={hasUserLoggedIn()}
        />
      ),
      tabPress: () => {
        updateParams({ tab: 'qna' });
        id
          ? handleEventOnTabPress(KissanEventType?.PROFILE_OTHERS_QUESTIONS)
          : handleEventOnSelf(KissanEventType?.PROFILE_SELF_QUESTIONS);
      },
    },
    hasUserLoggedIn() && {
      label: t('page.video'),
      component: (
        <AllVideos
          userProfile={userProfile!}
          id={id || undefined}
          hasUserLoggedIn={hasUserLoggedIn()}
          onReportBottomSheetOpen={onReportBottomSheetOpen}
        />
      ),
      tabPress: () => {
        updateParams({ tab: 'video' });
        id
          ? handleEventOnTabPress(KissanEventType?.PROFILE_OTHERS_VIDEOS)
          : handleEventOnSelf(KissanEventType?.PROFILE_SELF_VIDEOS);
      },
    },
  ].filter(Boolean); // Filter out any false values

  console.log("Profile component color => ", theme['cardbackground']?.val);

  return (
    <ScrollView style={{ flex: 1 }} contentContainerStyle={{ flexGrow: 1 }} testID='kisan_tId_profileDetailScreen'>
      <View style={{ flex: 1 }}>
        {/* <ScrollView> */}
        <View height={HEADER_HEIGHT} backgroundColor={'$cardbackground'}>
          <ProfileHeader
            userProfile={userProfile!}
            id={id || ''}
            name={name || ''}
            profileData={profileData}
            navigateToLogin={navigateToLogin}
            isLoading={isLoading}
          />
        </View>

        {Platform.OS != 'web' ? (
          // <View height={screenHeight + tabHeight}>
          <MaterialTopTabs.Navigator
            initialRouteName={id ? 'All' : 'Profile'}
            screenOptions={{
              lazy: true,
              tabBarLabelStyle: { color: theme['darkGrey']?.val },
              tabBarStyle: {
                backgroundColor: theme['cardbackground']?.val,
              },
            }}
            sceneContainerStyle={{ backgroundColor: theme['profileTabColor']?.val }}
          >
            {id ? (
              <MaterialTopTabs.Screen
                key={id}
                name="All"
                options={{ title: t('page.all') }}
                listeners={{
                  tabPress: () => handleEventOnTabPress(KissanEventType?.PROFILE_OTHERS_ALL),
                }}
              >
                {() => (
                  <ProfileAllTab
                    id={id?.toString() ?? ''}
                    userProfile={userProfile}
                    onReportBottomSheetOpen={onReportBottomSheetOpen}
                  />
                )}
              </MaterialTopTabs.Screen>
            ) : (
              <MaterialTopTabs.Screen
                key={'profile'}
                name="Profile"
                options={{ title: t('page.profile'), lazy: true, lazyPreloadDistance: 0 }}
                listeners={{
                  tabPress: () => handleEventOnSelf(KissanEventType?.PROFILE_SELF_MYPROFILE),
                }}
              >
                {() => (
                  <>
                    <View backgroundColor="$profileTabColor">
                      <MyProfileTab
                        userProfile={userProfile!}
                        languageChange={languageChange}
                        refCode={refCode}
                        setProfileData={setProfileData}
                      />
                    </View>
                  </>
                )}
              </MaterialTopTabs.Screen>
            )}
            {hasUserLoggedIn() && (
              <>
                <MaterialTopTabs.Screen
                  key={'activity'}
                  name="Activity"
                  options={{ title: t('page.activity') }}
                  listeners={{
                    tabPress: () =>
                      id
                        ? handleEventOnTabPress(KissanEventType?.PROFILE_OTHERS_ACTIVITY)
                        : handleEventOnSelf(KissanEventType?.PROFILE_SELF_ACTIVITY),
                  }}
                >
                  {() => (
                    <ProfileAllActivityComments
                      profileData={id ? profileData : userProfile}
                      id={id || undefined}
                      hasUserLoggedIn={hasUserLoggedIn()}
                      onReportBottomSheetOpen={onReportBottomSheetOpen}
                    />
                  )}
                </MaterialTopTabs.Screen>

                <MaterialTopTabs.Screen
                  key={'qna'}
                  name="Qna"
                  options={{ title: t('page.qna') }}
                  listeners={{
                    tabPress: () =>
                      id
                        ? handleEventOnTabPress(KissanEventType?.PROFILE_OTHERS_QUESTIONS)
                        : handleEventOnSelf(KissanEventType?.PROFILE_SELF_QUESTIONS),
                  }}
                >
                  {() => (
                    <AllQnaList
                      userProfile={userProfile!}
                      id={id || undefined}
                      hasUserLoggedIn={hasUserLoggedIn()}
                    />
                  )}
                </MaterialTopTabs.Screen>
                <MaterialTopTabs.Screen
                  key={'video'}
                  name="Video"
                  options={{ title: t('page.video') }}
                  listeners={{
                    tabPress: () =>
                      id
                        ? handleEventOnTabPress(KissanEventType?.PROFILE_OTHERS_VIDEOS)
                        : handleEventOnSelf(KissanEventType?.PROFILE_SELF_VIDEOS),
                  }}
                >
                  {() => (
                    <AllVideos
                      userProfile={userProfile!}
                      id={id || undefined}
                      hasUserLoggedIn={hasUserLoggedIn()}
                      onReportBottomSheetOpen={onReportBottomSheetOpen}
                    />
                  )}
                </MaterialTopTabs.Screen>
              </>
            )}
          </MaterialTopTabs.Navigator>
        ) : (
          // </View>
          <>
            <View
              style={{
                flexDirection: 'row',
                justifyContent: 'space-around',
                backgroundColor: '#fff',
                paddingVertical: 10,
              }}
            >
              {tabs.map((tab, index) => (
                <Pressable
                  key={index}
                  style={{
                    padding: 10,
                    width: '25%',
                    borderBottomWidth: selectedIndex === index ? 2 : 0,
                    borderBottomColor: selectedIndex === index ? '#000' : 'transparent',
                  }}
                  onPress={() => {
                    setSelectedIndex(index);
                    tab?.tabPress();
                  }}
                  testID='kisan_tId_tabPress'
                >
                  <Text fontSize={16} color={'$darkGrey'}>
                    {tab?.label}
                  </Text>
                </Pressable>
              ))}
            </View>
            <View flex={1} backgroundColor={theme['cardbackground']?.val}>
              {tabs[selectedIndex]?.component}
            </View>
          </>
        )}
        {/* </ScrollView> */}
      </View>
       {Platform.OS === 'web' ? <Footer sourcepage="profile" /> : null}
      {languageChangeBottomSheet && (
        <UIBottomSheet
          open={languageChangeBottomSheet}
          animation={'quick'}
          snapPoints={[70]}
          onOpenChange={setLanguageChangeBottomSheet}
          children={
            <ChangeLanguageBottomSheet
              setLanguageChangeBottomSheet={setLanguageChangeBottomSheet}
              onLanguageChange={onLanguageChange}
            />
          }
        />
      )}
    </ScrollView>
  );
}

ProfileDetailScreen.title = 'Material Top Tabs';
ProfileDetailScreen.linking = linking;
ProfileDetailScreen.options = {
  headerShown: true,
  cardStyle: { flex: 1 },
};
